import { logUnusedKeys } from '@/model/Utils';

export default function (other) {
  other = other || {};
  let result = {
    range: {
      from: other.range?.from || null,
      until: other.range?.until || null,
    },
    orgIds: other.orgIds || [],
    buIds: other.buIds || [],
    buTypes: other.buTypes || [],
    affiliateId: other.affiliateId || null,
    banner: other.banner || null,
    campaign: other.campaign || null,
    // TXF: true takes the taxes money OUT of Total Deposits / Net.
    excludeTxf: other.excludeTxf === true,
  };
  logUnusedKeys('DashboardSearchRequest', result, other);
  return result;
}
